import { Injectable, EventEmitter } from '@angular/core';
import { ZONE } from '../zone/zone.service';

@Injectable({
  providedIn: 'root'
})
export class UnionOfficeService {

  is_display_union_office_register_component = false;
  unionOfficeUpdate = new EventEmitter<ZONE>();

  downloadUnionOffice = new EventEmitter<boolean>();

  private _union_office_data: UNION = null;


  constructor() { }
  set set_union_office_data(union_office) {
    this._union_office_data = union_office;
  }

  get get_union_office_data() {
    return this._union_office_data;
  }
}


export interface UNION {
  id: number;
  name: string;
}